import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Account } from 'api/account';

export interface AccountSliceState {
  data: Account | null;
  error: null | string;
  loading: boolean;
}

const INITIAL_STATE: AccountSliceState = {
  data: null,
  error: null,
  loading: false,
};

export const slice = createSlice({
  name: 'account',
  initialState: INITIAL_STATE,

  reducers: (create) => ({
    set: create.reducer(
      (state: AccountSliceState, action: PayloadAction<Account>) => {
        return {
          ...state,
          loading: false,
          error: null,
          data: {
            ...state.data,
            ...action.payload,
          },
        };
      },
    ),
  }),
});
